export type PlatformTermsConsent = {
  userId: string;
  contractId?: string;
  signedAt?: Date;
  declinedAt?: Date;
};

export const USER_TYPE = {
  NEW: "newUser",
  EXISTING: "existingUser",
};

export type userType = (typeof USER_TYPE)[keyof typeof USER_TYPE];
